export default {
  id: 'healthHistory/SURGICAL_HISTORY/v1',
  formSchema: {
    title: 'encounter:widget.healthHistory.surgicalHistory',
    type: 'object',
    required: ['id001'],
    properties: {
      id001: {
        type: 'string',
        title: 'encounter:widget.healthHistory.surgicalHistory',
        minLength: 1
      }
    }
  },
  uiSchema: {
    id001: { 'ui:widget': 'customCKEditorWidget' },
    'x-customClass': 'problem-description-widget'
  }
};
